import React, { PureComponent } from 'react'
import { withTheme } from 'react-fela'
import { createComponent } from '@ycos/fela'

class NotificationIcon extends PureComponent {
  render() {
    const { type } = this.props
    const iconColor = this.props.theme.custom.notification[`${type}Color`]

    return (
      <IconContainer type={type}>
        {type === 'info' && (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Elements/Icon/Information/Blue/24px">
                <g id="24_Information">
                  <rect
                    id="Rectangle-path"
                    transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
                    x="-1.77635684e-15"
                    y="0"
                    width="24"
                    height="24"
                  />
                  <path
                    d="M11,17 L12,17 L12,10 L11,10 L11,17 Z M11.5,0 C5.149,0 0,5.149 0,11.5 C0,17.851 5.149,23 11.5,23 C17.851,23 23,17.851 23,11.5 C23,5.149 17.851,0 11.5,0 Z M11.5,22 C5.71,22 1,17.29 1,11.5 C1,5.71 5.71,1 11.5,1 C17.29,1 22,5.71 22,11.5 C22,17.29 17.29,22 11.5,22 Z M11.5,6 C10.948,6 10.5,6.448 10.5,7 C10.5,7.552 10.948,8 11.5,8 C12.052,8 12.5,7.552 12.5,7 C12.5,6.448 12.052,6 11.5,6 Z"
                    id="Shape"
                    fill={iconColor}
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </svg>
        )}
        {type === 'success' && (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Elements/Icon/Confirmation/Green/24px">
                <g>
                  <rect
                    id="Rectangle-path"
                    transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
                    x="-1.77635684e-15"
                    y="0"
                    width="24"
                    height="24"
                  />
                  <path
                    d="M11.5,0 C5.149,0 0,5.149 0,11.5 C0,17.851 5.149,23 11.5,23 C17.851,23 23,17.851 23,11.5 C23,5.149 17.851,0 11.5,0 Z M11.5,22 C5.71,22 1,17.29 1,11.5 C1,5.71 5.71,1 11.5,1 C17.29,1 22,5.71 22,11.5 C22,17.29 17.29,22 11.5,22 Z M9.015,14.933 L5.978,11.896 L5.271,12.603 L9.015,16.347 L17.452,7.91 L16.745,7.203 L9.015,14.933 Z"
                    id="Shape"
                    fill={iconColor}
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </svg>
        )}
        {type === 'error' && (
          <svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Notification-Specs" transform="translate(-1001.000000, -362.000000)">
                <g id="informational---1-line" transform="translate(993.000000, 354.000000)">
                  <g id="Elements/Icon/Warning/Black/24px" transform="translate(8.000000, 8.000000)">
                    <rect
                      id="Rectangle-path"
                      transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
                      x="-1.77635684e-15"
                      y="0"
                      width="24"
                      height="24"
                    />
                    <path
                      d="M12,6 L11,6 L11,13 L12,13 L12,6 Z M11.5,0 C5.149,0 0,5.149 0,11.5 C0,17.851 5.149,23 11.5,23 C17.851,23 23,17.851 23,11.5 C23,5.149 17.851,0 11.5,0 Z M11.5,22 C5.71,22 1,17.29 1,11.5 C1,5.71 5.71,1 11.5,1 C17.29,1 22,5.71 22,11.5 C22,17.29 17.29,22 11.5,22 Z M11.5,15 C10.948,15 10.5,15.448 10.5,16 C10.5,16.552 10.948,17 11.5,17 C12.052,17 12.5,16.552 12.5,16 C12.5,15.448 12.052,15 11.5,15 Z"
                      id="Shape"
                      fill={iconColor}
                      fillRule="nonzero"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )}
      </IconContainer>
    )
  }
}

const IconContainer = createComponent(
  'IconContainer',
  () => ({
    width: '24px',
    height: '24px'
  }),
  'div'
)

export default withTheme(NotificationIcon)
